import { QueueData } from '@/endpoints/schemas'

export interface OpenedQueueData {
	dirty: boolean
	form: QueueData
	original: QueueData
	parsedEditMode: boolean
	tab: QueueTab
}

export enum QueueTab {
	Dependencies = 'Dependencies',
	Deployments = 'Deployments',
	Overview = 'Overview',
	PhysicalOptions = 'PhysicalOptions',
	Preview = 'Preview',
	Validation = 'Validation',
	Versions = 'Versions',
}
